import React, { useState, useEffect } from 'react'
import MaterialTable from '@material-table/core';
import { Paper, TablePagination } from '@mui/material';
import axios from 'axios'; 
import { useDispatch, useSelector } from 'react-redux';
import { KTSVG } from '../../../../_metronic/helpers';
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall';
import { RootState } from '../../../../setup';
import { stylesMUIInput } from '../../stylesMUIInput';
import { CircularProgressWhiteStyled, MTableBodyRowStyled } from '../../QuotesGridPage/Table/Table.styled';
import SearchInputToolbar from '../SearchInputToolbar';
import CircleIcon from '@mui/icons-material/Circle';
import { v4 as uuidv4 } from 'uuid';
import GetClassWarningModal from './GetClassWarningModal';
import RequireClassITModal from './RequireClassITModal';
import { tableStyles } from '../Tables/TableStyles';
import NMFCClassErrorModal from '../../../pages/book/NewBooking/NMFCClassErrorModal';

let cancelToken
const GET_NMFCS = 'api/v1/database/nmfc/search'
const GET_NMFC = 'api/v1/database/nmfc/item'

const NMFCTable = ({ open, selectNMFC, handleClose, searchFormik, setOpenClearRateToEditModal, formikValues, setNewValuesWhenRateCleared}) => {
    const classes = tableStyles()
    const dispatch = useDispatch()
    const [tableResults, setTableResults] = useState([])
    const [totalResults, setTotalResults] = useState(0)
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')
    const [pageNumber, setPageNumber] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [selectedId, setSelectedId] = useState('')
    const [openGetClassWarningModal, setOpenGetClassWarningModal] = useState(false)
    const [openRequireClassITModal, setOpenRequireClassITModal] = useState(false)
    const [openNMFCClassErrorModal, setOpenNMFCClassErrorModal] = useState(false)

    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    const storedRender = (rowData) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <CircleIcon style={{ color: rowData.stored ? '#47BE7D' : '#F1416C' }} />
            </div>
        )
    }

    const classRender = (rowData) => {
        return (
            <div style={{textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {
                    rowData.itemClass ? rowData.itemClass :
                    <button
                        className='btn btn-primary d-flex align-items-center justify-content-center'
                        style={{width: 109.72}}
                        disabled={rowData.loading}
                        onClick={() => {
                            setSelectedId(rowData.id)
                        }}
                    >
                        {rowData.loading ? <CircularProgressWhiteStyled style={{height: 16, width: 16}} className='ms-2'/> : 'Get Class'}
                    </button>
                }
            </div>
        )
    }

    const noteRender = (rowData) => {
        return (
            <>
              {rowData.noteDescription 
                ? <>
                    {rowData.noteDescription?.includes('<br>') ?
                        <div dangerouslySetInnerHTML={{ __html: rowData.noteDescription }} />
                        : <span>{rowData.noteDescription}</span>
                    }
                </>
                : null
              }
            </>
        )
    }

    const descriptionRender = (rowData) => {
        return (
            <div className='row'>
                <div className='col-12'>
                    {rowData.itemDescription?.includes('<br>') ?
                        <div dangerouslySetInnerHTML={{ __html: rowData.itemDescription}} />
                        : <span>{rowData.itemDescription}</span>
                    }
                </div>
                {rowData.subDescription ? <div className='col-12'>Sub Description: {rowData.subDescription}</div> : null}
            </div>
        )
    }

    const [columns] = useState([
        {title: 'NMFC', field: 'itemNumber',},
        {title: 'Stored', sorting: false, headerStyle: {textAlign: 'center'}, render: storedRender,},
        {title: 'Class', field: 'itemClass', sorting: false, render: classRender, cellStyle: {width: 120, minWidth: 120}, headerStyle: {textAlign: 'center', width: 120, minWidth: 120}},
        {title: 'Group', field: 'groupDescription', cellStyle: {width: 200, minWidth: 200}, headerStyle: {width: 200, minWidth: 200}},
        {title: 'Description', field: 'itemDescription', render: descriptionRender, cellStyle: {width: 300, minWidth: 300}, headerStyle: {width: 300, minWidth: 300}},
        {title: 'Note', field: 'noteDescription', render: noteRender, cellStyle: {width: 300, minWidth: 300}, headerStyle: {width: 300, minWidth: 300}},
    ])

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    const hasValidClass = (rowData) => {
        return rowData?.itemClass && rowData.itemClass !== '-'
    }

    const selectNMFCTable = (e, rowData) => {
        if(!hasValidClass(rowData)) return

        switch (e.detail) {
            case 1:
                break;
            case 2:
                if(rowData?.itemNumber?.length === 9){
                    if(formikValues?.carrierInformation?.name){
                        setOpenClearRateToEditModal(true)
                        setNewValuesWhenRateCleared({
                            valuesFor: ``,
                            originalValues: '',
                            values: e.target.values,
                            functionToDo: () => {
                                selectNMFC(rowData)
                            }
                        })
                    }else{
                        selectNMFC(rowData)
                    }
                }else{
                    setOpenGetClassWarningModal(true)
                }
                
                break;
        }
       
    }

    useEffect(() => {
        if(open){
            if(search){
                setLoading(true)

                if (typeof cancelToken != typeof undefined) {
                    cancelToken.cancel('Operation canceled due to new request.')
                }
                cancelToken = axios.CancelToken.source()

                axios.get(GET_NMFCS, {
                    cancelToken: cancelToken.token,
                    params: {
                        page: pageNumber + 1,
                        limit: rowsPerPage,
                        keyword: search
                    }
                }).then(response => {
                    let NMFCS = response.data.data.results?.NMFCCodes.map((codes) => ({...codes, id: uuidv4()}))

                    NMFCS?.forEach((nmfc, index)=> {
                        if(NMFCS?.filter(n => n.itemNumber === nmfc.itemNumber).length > 1){
                            let duplicated = NMFCS?.filter(n => n.itemNumber === nmfc.itemNumber)
                            NMFCS = NMFCS?.filter(n => n.itemNumber !== nmfc.itemNumber)
                            NMFCS?.splice(index + 1, 0, ...duplicated)
                        }
                    })

                    setTableResults(NMFCS?.sort((a, b) => parseInt(a.itemNumber) - parseInt(b.itemNumber))) 
                    setTotalResults(response.data.data.results.totalCount)
                    setLoading(false)
                }).catch(error => {
                    if(error?.response?.data?.error?.message === 'Empty classIT credentials.'){
                        setOpenRequireClassITModal(true)
                        setLoading(false)
                    }else{  
                        checkErrorAPICall(error, dispatch, 'NMFC Numbers')
                    }
                    
                })
            }else{
                setPageNumber(0)
                setTotalResults(0)
                setTableResults([])
                setLoading(false)
            }
        }else{
            setTimeout(() => {
                setTableResults([])
            }, 500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, search, pageNumber, rowsPerPage])

    useEffect(() => {
      if(searchFormik){
        setSearch(searchFormik)
      }
    }, [searchFormik])

    useEffect(() => {
        if(selectedId){
            setTableResults(tableResults.sort((a, b) => parseInt(a.itemNumber) - parseInt(b.itemNumber)).map((r) => {
                if(r.id === selectedId){
                    return ({
                        ...r,
                        loading: true
                    })
                }else{
                    return r
                }
            }))

            const itemSelected = tableResults.find(result => result.id === selectedId)

            axios.get(`${GET_NMFC}/${itemSelected?.itemNumber}`).then(response => {
                let newArray = [...tableResults]
                let index = tableResults.map(result => result.id).indexOf(selectedId)
                let newItems = []
                let subItemResults = response.data.data.results

                if(response.data.data.results.subItems.length){
                    if(newArray.filter(result => result.itemNumber === itemSelected.itemNumber).length > 1){
                        newItems = response.data.data.results.subItems.map((subItem) => ({
                            ...itemSelected,
                            itemNumber: `${itemSelected.itemNumber}-${subItem.subNumber}`,
                            itemClass: subItem.subClass,
                            itemDescription: response.data.data.results.itemDescription,
                            subDescription: subItem.subDescription,
                            noteDescription: response.data.data.results.noteDescription,
                            groupDescription: newArray.filter(result => result.itemNumber === itemSelected.itemNumber)[0].groupDescription,
                            id: uuidv4()
                        }))
                    }else{
                        newItems = response.data.data.results.subItems.map((subItem) => ({
                            ...itemSelected,
                            itemNumber: `${itemSelected.itemNumber}-${subItem.subNumber}`,
                            itemClass: subItem.subClass,
                            itemDescription: response.data.data.results.itemDescription,
                            subDescription: subItem.subDescription,
                            noteDescription: response.data.data.results.noteDescription,
                            id: uuidv4()
                        }))
                    }
                }else{
                    const items = tableResults.filter(result => result.itemNumber === itemSelected.itemNumber)
                    index = tableResults.map(result => result.id).indexOf(items[0].id)

                    newItems = items.map((item) => ({
                        ...item,
                        itemNumber: subItemResults.itemNumber,
                        itemClass: subItemResults.itemClass,
                        noteDescription: subItemResults.noteDescription || item.noteDescription,
                        itemDescription: subItemResults.itemDescription || item.itemDescription,
                    })) 
                }

                if(subItemResults.itemNumber && subItemResults.itemClass){
                    newArray = newArray.filter(result => result.itemNumber !== itemSelected.itemNumber)
                    newArray.splice(index, 0, ...newItems)
                    setTableResults(newArray)
                }else{
                    setOpenNMFCClassErrorModal(true)
                }

                setTableResults(newArray.sort((a, b) => parseInt(a.itemNumber) - parseInt(b.itemNumber)).map((r) => {
                    if(r.id === selectedId){
                        return ({
                            ...r,
                            loading: false
                        })
                    }else{
                        return r
                    }
                }))
            }).catch(error => {
                checkErrorAPICall(error, dispatch, 'NMFC Number')
            }) 
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId])

    return (
        <div>
            <div className='bg-secondary rounded-top py-2 px-4 mb-4'>
                <div className="row d-flex justify-content-between p-0 border-bottom border-light my-2">
                    <div className="col-8">
                        <h5 className="modal-title">NMFCs Lookup</h5>
                    </div>                
                    <div className="col-1 d-flex btn btn-icon btn-sm btn-active-light-primary me-3" onClick={handleClose}>
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-2x"
                        />
                    </div>
                </div>
                <div className="col-5 col-sm-3 col-md-2 mb-8">
                    <SearchInputToolbar
                        searchTable={search}
                        handleSearch={handleSearch}
                        className="w-100"
                        results={tableResults}
                    />
                </div>
            </div>
                <MaterialTable
                    isLoading={loading}
                    data={tableResults}
                    columns={columns as any}
                    style={{boxShadow: 'none', fontFamily: 'Poppins !important'}}
                    options={{
                        search: false,
                        toolbar: false,
                        thirdSortClick: false,
                        actionsColumnIndex: -1,
                        filtering: false,
                        draggable: false,
                        rowStyle: (data, idx) => {
                            const disabled = data.itemClass === '-'
                            const base = idx%2 !== 0 ? { backgroundColor: '#f4f4f4' } : { backgroundColor: '#ffff' }
                            return disabled
                                ? { ...base, opacity: 0.5, cursor: 'not-allowed' }
                                : base
                        },
                        headerStyle: { position: 'sticky', top: 0 },
                        searchFieldStyle: {
                            ...stylesMUIInput(fontSize),
                            marginTop: 10,
                            marginBottom: 10,
                            minWidth: '190px'
                        },
                        pageSizeOptions: [],
                        pageSize: rowsPerPage,
                        maxBodyHeight: fontSize >= 13 ? `${window.innerHeight - 355}px` : fontSize === 9 ? `${window.innerHeight - 330}px` : `${window.innerHeight - 340}px`,
                    }}
                    components={{
                        Container: (props) => <Paper className={classes.tableQuotesGrid} {...props}/>,
                        Row: rowProps => {
                            const disabled = rowProps.data.itemClass === '-'
                            return <MTableBodyRowStyled
                                {...rowProps}
                                onRowClick={(e) => {
                                    if(!disabled) selectNMFCTable(e, rowProps.data)
                                }}
                                onMouseEnter={(e) => { if(!disabled) e.target.parentElement.classList.add("hoverRow") }}
                                onMouseLeave={(e) => e.target.parentElement.classList.remove("hoverRow")}
                            />
                        },
                        Pagination: props => <TablePagination {...props} count={totalResults} page={pageNumber} onPageChange={(e, page) => setPageNumber(page)}/>
                    }}
                    localization={{
                        pagination: {
                            labelRows: '',
                        },
                    }}
                    onPageChange={(page) => setPageNumber(page)}
                    onRowsPerPageChange={(number) => setRowsPerPage(number)}
                />
            <GetClassWarningModal
                open={openGetClassWarningModal}
                setOpen={setOpenGetClassWarningModal}
            />
            <RequireClassITModal
                open={openRequireClassITModal}
                setOpen={setOpenRequireClassITModal}
            />
            <NMFCClassErrorModal
                open={openNMFCClassErrorModal}
                setOpen={setOpenNMFCClassErrorModal}
                selectedNMFC={tableResults.find(result => result.id === selectedId)?.itemNumber || ''}
                setSelectedId={setSelectedId}
            />
        </div>
    )
}

export default NMFCTable